/**
 * Central image registry for Lima Dental Group.
 * Replace a URL here and every section updates automatically.
 */
export const images = {
  /** Official Lima Dental Group wordmark (light version, for dark backgrounds). */
  logo: 'https://cdn.magicpatterns.com/uploads/gREXhdCD4EcsBZuCktEDjN/67996f9af3656be5fa60d2a3_Lima_Tooth_logo.png',

  /**
   * Approved photography of Dr. Julio Lima, DDS.
   * Suggested export names for production:
   *  heroConsult   → Dr-Julio-Lima-DDS-Miami-Lakes-Patient-Care.jpg
   *  portrait      → Dr-Julio-Lima-DDS-Miami-Lakes-Dentist.jpg
   *  examining     → Dr-Julio-Lima-DDS-Miami-Lakes-Dental-Care.jpg
   *  consultLight  → Lima-Dental-Group-Miami-Lakes-Patient-Consultation.jpg
   */
  julio: {
    /** Wide, dark, cinematic consultation with negative space on the left. */
    heroConsult:
      'https://cdn.magicpatterns.com/uploads/gXFcSGg5U8k2XUb5FikKcB/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(1).png',
    /** Vertical portrait in a white coat inside the clinic. */
    portrait:
      'https://cdn.magicpatterns.com/uploads/cVvT6XS48RQCQWMfeEsEWE/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(2).png',
    /** Dental exam with instruments. */
    examining:
      'https://cdn.magicpatterns.com/uploads/gbSNi8euB6NYXFAAs8JZ4r/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(3).png',
    /** Bright consultation, talking naturally with a patient. */
    consultLight:
      'https://cdn.magicpatterns.com/uploads/ksvrAGi95EAXDfujpT6fSp/ChatGPT_Image_Aug_17,_2026,_03_46_35_PM_(4).png',
  },

  /** Hero: Dr. Julio Lima, DDS with a patient (wide, cinematic). */
  hero: 'https://cdn.magicpatterns.com/uploads/gXFcSGg5U8k2XUb5FikKcB/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(1).png',

  /** Clinic gallery — real Lima Dental Group photography (Suite 106, Miami Lakes). */
  clinic: {
    exterior:
      'https://cdn.magicpatterns.com/uploads/q3dMTiBnSC5dC3XprtUm7Z/ChatGPT_Image_Aug_25,_2026,_05_57_29_PM_(4).png',
    reception:
      'https://cdn.magicpatterns.com/uploads/9Ntg8R968cSkuqv3yGkJHn/ChatGPT_Image_Aug_25,_2026,_05_57_28_PM_(1).png',
    waiting:
      'https://cdn.magicpatterns.com/uploads/e5W8ogtci2hJjYSfKADiWy/ChatGPT_Image_Aug_25,_2026,_05_57_29_PM_(6).png',
    treatment:
      'https://cdn.magicpatterns.com/uploads/gRCDaW6ehCJkWGTFXii8ai/ChatGPT_Image_Aug_25,_2026,_05_57_30_PM_(8).png',
    technology:
      'https://cdn.magicpatterns.com/uploads/cYC59hPzHJWBHSS7oTDdFj/ChatGPT_Image_Aug_25,_2026,_05_57_29_PM_(3).png',
  },

  /** Services */
  services: {
    prevention:
      'https://cdn.magicpatterns.com/uploads/ksvrAGi95EAXDfujpT6fSp/ChatGPT_Image_Aug_17,_2026,_03_46_35_PM_(4).png',
    implant:
      'https://cdn.magicpatterns.com/patterns/generated-images/31cd2b8a-32ac-4e57-a005-1ee2fa57d070.jpg',
    cosmetic:
      'https://cdn.magicpatterns.com/patterns/generated-images/71533b76-2873-4486-b144-3f4204ea3f83.jpg',
    emergency:
      'https://cdn.magicpatterns.com/uploads/gbSNi8euB6NYXFAAs8JZ4r/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(3).png',
  },

  /** Invisalign feature */
  invisalign:
    'https://cdn.magicpatterns.com/uploads/i8KNktxo7X4PBDGVz5x68v/ChatGPT_Image_Aug_26,_2026,_11_33_27_AM.png',

  /** Dr. Julio Lima, DDS */
  doctorPortrait:
    'https://cdn.magicpatterns.com/uploads/cVvT6XS48RQCQWMfeEsEWE/ChatGPT_Image_Aug_17,_2026,_03_46_34_PM_(2).png',

  /**
   * Before / after cases — matched pairs in natural color.
   * Each pair is the same patient with identical framing, lighting and lip
   * position; only the dental outcome changes.
   */
  cases: {
    before1:
      'https://cdn.magicpatterns.com/patterns/generated-images/87a357e6-e430-4566-8fcb-90271389f697.jpg',
    after1:
      'https://cdn.magicpatterns.com/patterns/generated-images/27e633a9-584f-4d52-8d65-45e044dfa73d.jpg',
    before2:
      'https://cdn.magicpatterns.com/patterns/generated-images/07210c0f-2068-4345-b6b8-dfed3d45c528.jpg',
    after2:
      'https://cdn.magicpatterns.com/patterns/generated-images/722dfaf1-6aa1-466d-a34a-96d1c761b63a.jpg',
    before3:
      'https://cdn.magicpatterns.com/patterns/generated-images/7ddba132-45a6-465d-ab9d-6abe1ff29a7f.jpg',
    after3:
      'https://cdn.magicpatterns.com/patterns/generated-images/85beb4a0-58fc-4513-8c2f-c250925cfb24.jpg',
    before4:
      'https://cdn.magicpatterns.com/patterns/generated-images/acc10094-be9e-434b-b26a-b601ca4384a4.jpg',
    after4:
      'https://cdn.magicpatterns.com/patterns/generated-images/a6b8a6a9-b227-44fe-94e1-fce3f8cf02b6.jpg',
    before5:
      'https://cdn.magicpatterns.com/patterns/generated-images/8707b821-d72c-4789-a5a1-10fe39c31b08.jpg',
    after5:
      'https://cdn.magicpatterns.com/patterns/generated-images/9f4c017b-8c77-41d0-b35f-0de78a93be02.jpg',
    before6:
      'https://cdn.magicpatterns.com/patterns/generated-images/f28e2c64-8b77-4f76-960f-598e87be51a9.jpg',
    after6:
      'https://cdn.magicpatterns.com/patterns/generated-images/94995274-eba1-4d21-abd6-9529bed7d79f.jpg',
  },
} as const
